import { useEffect } from "react";
import { Link } from "react-router-dom";
import { SEOHead } from "@/components/SEOHead";
import Footer from "@/components/Footer";

const Bewertung = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://api.zappages.de/js/form_embed.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-neutral-50 flex flex-col">
      <SEOHead
        title="Bewerte uns — Easy Umzug"
        description="Wir freuen uns über Ihr Feedback! Bitte nehmen Sie sich kurz Zeit, um unseren Umzugsservice zu bewerten."
        canonical="https://easy-umzugsservice.de/bewertung"
      />
      <main className="flex-grow pt-12 pb-16 flex items-center justify-center">
        <div className="container mx-auto px-4 max-w-3xl">
          <div className="bg-white rounded-2xl shadow-xl p-6 md:p-10 border border-neutral-100">
            <div className="flex flex-col items-center mb-8">
              <Link to="/" className="transition-transform hover:scale-105 duration-300">
                <img 
                  src="https://images.leadconnectorhq.com/image/f_webp/q_80/r_300/u_https://assets.cdn.filesafe.space/Zrqvy6cNzSbnzDV55cv1/media/6936d9b74b202f068ab37a46.png" 
                  alt="Easy Umzug Logo" 
                  className="h-16 w-auto mb-6"
                />
              </Link>
              <h1 className="text-3xl md:text-4xl font-bold text-center text-neutral-900 mb-4">
                Ihre Meinung zählt!
              </h1>
              <p className="text-neutral-600 text-center text-lg max-w-xl">
                Vielen Dank, dass Sie sich für Easy Umzug entschieden haben. Wir möchten uns stetig verbessern und freuen uns über Ihre ehrliche Bewertung.
              </p>
            </div>

            <div className="w-full min-h-[600px] bg-neutral-50 rounded-xl overflow-hidden border border-neutral-200">
              <iframe 
                src="https://api.zappages.de/widget/survey/7bhL5qhj38QS2bWT8VfK" 
                style={{ border: 'none', width: '100%', minHeight: '600px' }} 
                scrolling="no" 
                id="7bhL5qhj38QS2bWT8VfK" 
                title="survey"
              ></iframe>
            </div>
            
            <div className="mt-8 text-center text-sm text-neutral-400">
              Ihre Daten werden sicher und vertraulich behandelt.
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Bewertung;
